<template>
  <div class="filters flex flex-wrap items-center justify-end">

      <div class="slot-left flex justify-end items-center mr-auto">
        <slot name="left"></slot>
      </div>

    <vs-input
        v-if="value !== null"
        class="quick-search"
        :placeholder="placeHolder()"
        v-model="search"
    />

    <div class="actions flex justify-end items-center">

      <div class="slot-right flex justify-end items-center">
        <slot name="right"></slot>
      </div>

      <!-- ACTION - DROPDOWN -->
      <vs-dropdown v-if="$slots.default" class="cursor-pointer" vs-trigger-click >

        <vs-button
            class="mt-2 py-3 px-4 flex items-end justify-center content-center text-lg shadow-drop"
            color="primary">
          <span class="mr-2 leading-none">Actions</span>
          <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
        </vs-button>

        <vs-dropdown-menu class="actions-dropdown">
          <slot></slot>
        </vs-dropdown-menu>
      </vs-dropdown>
    </div>
  </div>

</template>

<script>

export default {
  name: 'GridActionBar',
  props: {
    value: {
      type: String,
    },
  },
  data() {
    return {
      search: '',
    };
  },
  created() {
    this.search = this.value;
  },
  watch: {
    search: {
      handler(newSearch) {
        this.$emit('input', newSearch);
      },
      immediate: true,
    },
  },
  methods: {
    placeHolder() {
      return this.$t('Search') + '...'
    }
  }
};
</script>

<style lang="scss">
  .actions-button {
    min-width: 100px;
  }

  .vs-input--placeholder {
    font-size: 1em;
  }
  .quick-search {
    max-width: 216px;
  }

  @media (max-width: 576px) {
    .quick-search {
      max-width: 100%;
    }

    .filters {
      .slot-right,
      .actions-dropdown {
        margin-top: .5rem;
      }
    }
  }
</style>
